import { Component, OnInit, HostListener } from '@angular/core';

@Component({
  selector: 'arsultima-scroll-indicator',
  templateUrl: './scroll-indicator.component.html',
  styleUrls: ['./scroll-indicator.component.scss'],
})
export class ScrollIndicatorComponent implements OnInit {
  isVisible = false;
  private readonly SCROLL_THRESHOLD = 300; // pixels below fold to show indicator

  @HostListener('window:scroll', ['$event'])
  onScroll() {
    this.checkScrollVisibility();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScrollVisibility();
  }

  ngOnInit() {
    this.checkScrollVisibility();
  }

  private checkScrollVisibility() {
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const scrollTop = window.scrollY;
    const remainingScroll = scrollHeight - (scrollTop + clientHeight);

    // Show indicator if there's more than SCROLL_THRESHOLD pixels below the fold
    this.isVisible = remainingScroll > this.SCROLL_THRESHOLD;
  }

  scrollToBottom() {
    const clientHeight = document.documentElement.clientHeight;
    const currentScroll = window.scrollY;

    window.scrollTo({
      top: currentScroll + clientHeight,
      behavior: 'smooth',
    });
  }
}
